<section>

    <nav class="navbar navbar-expand-lg navbar-dark bg-white">
        <a class="navbar-brand" routerLink=''>
            <img src="assets/Image/Logo/Jobtec.svg" width="200" alt="Logo de Jobtec">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
          <div class="navbar-nav text-dark">
            <a class="nav-item nav-link text-dark" routerLink='/quienes-somos' >Quienes Somos<span class="sr-only">(current)</span></a>
            <a class="nav-item nav-link text-dark" routerLink='/contacto'>Contacto</a>
            <a class="nav-item nav-link text-dark" routerLink='/sign-in'>Sign in</a>
          </div>
        </div>
        <a class="navbar-brand">
            <img src="assets/Image/Logo/descarga.png" width="150" alt="Emocion de Jobtec">
        </a>
      </nav>

</section>